import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  data: {
    mainFilter: "",
    revenueFilter: "",
    sessionsFilter: "",
    purchaseFilter: "",
    transactionsFilter: "",
    sessionlengthFilter: "",
    dashboardSessionFilter: "",
  },
};

const adminDashboardTimeRangeSlice = createSlice({
  name: "Save the time range selection",
  initialState,
  reducers: {
    updateTimeRange(state, action) {
      state.data = action.payload;
    },
    resetSavedTransactionLogsSearchFilter(state) {
      state.data = initialState.data;
    },
  },
});

export const { updateTimeRange, resetSavedTransactionLogsSearchFilter } = adminDashboardTimeRangeSlice.actions;
export default adminDashboardTimeRangeSlice.reducer;
